import React, {Component} from 'react'
import { Row, Col } from 'antd';
import Button from '../common/atoms/DSButton';
import { Breadcrumb } from '../common/atoms';
import { Modal, Checkbox, Input, Spin, Layout } from 'antd'

const { TextArea } = Input;
const { Content } = Layout;
class Facilities extends Component {

  constructor(props) {
    super(props)
    this.state = {
	loading: false,
	msg: '',
	msg_color: '',
	requested: false,
	modalVisible: true,
	facilities: [],
	notes: '',
	availed_facilities: [],
			healthy_diet_checked: false,
			weekly_yoga_checked: false,
			desktop_yoga_checked: false,
			nutritionist_checked: false,
			masala_bhangra_checked: false,
			zumba_checked: false,
			helth_talks_checked: false,
			ergonomics_checked: false,
			others_checked: false,
			errors: false
    }
  }

  handleOk(){
	if (this.state.facilities.length > 0) {
			let that = this
			let request_body = { facilities: this.state.facilities, notes: this.state.notes }
			let url = window.API_URL + 'corporate/facilities/request'
			this.setState({loading: true, errors: false})
			window.axios.post(url, request_body)
	    .then(function (response) {
	      that.setState({msg_color: 'green', loading: false, requested: true, modalVisible: false, msg: 'Your request posted successfully our account managers will respond within 24 hours.'})
	    })
	    .catch(function (error) {
	      that.setState({msg_color: 'red', loading: false, requested: true, modalVisible: false, msg: 'Something went wrong or feature is not available at the moment. please contact account managers.'})
	      console.log(error);
	    })
	}
	else {
		this.setState({errors: true})
	}
  }

  handleCancel = () => {
	this.setState({modalVisible: false})
  }

  enableModal = () => {
	this.setState({modalVisible: true})
  }

  updateNotes = (e) => {
	this.setState({notes: e.target.value})
  }

  updateFacility = (facility, e) => {
	let checked = e.target.checked
	if (checked) { this.addFacilityToList(facility) }
	else { this.removeFacilityFromlist(facility) }
  }

	addFacilityToList(facility){
		let facilities = this.state.facilities
		facilities.push(facility)
		facilities = Array.from(new Set(facilities))
		this.setState({facilities: facilities}, function(){
			this.updateCheckedList(facility, 'add')
		})
		console.log(facilities)
	}

	removeFacilityFromlist(facility){
		let facilities = this.state.facilities
		facilities = facilities.filter((item) => item !== facility)
		facilities = Array.from(new Set(facilities))
		this.setState({facilities: facilities}, function(){
			this.updateCheckedList(facility, 'remove')
		})
		console.log(facilities)
	}

	updateCheckedList(facility, action){
		if (action === 'add'){
			if (facility === 'Healthy Diet Plan'){ this.setState({healthy_diet_checked: true})}
			else if (facility === 'Weekly Yoga Session'){ this.setState({weekly_yoga_checked: true})}
			else if (facility === 'Desktop Yoga'){ this.setState({desktop_yoga_checked: true})}
			else if (facility === 'Nutritionist Session'){ this.setState({nutritionist_checked: true})}
			else if (facility === 'Masala Bhangra'){ this.setState({masala_bhangra_checked: true})}
			else if (facility === 'Zumba Sessions'){ this.setState({zumba_checked: true})}
			else if (facility === 'Health Talks'){ this.setState({helth_talks_checked: true})}
			else if (facility === 'Ergonomics Session'){ this.setState({ergonomics_checked: true})}
			else if (facility === 'Others'){ this.setState({others_checked: true})}
		}
		else if (action === 'remove') {
			if (facility === 'Healthy Diet Plan'){ this.setState({healthy_diet_checked: false})}
			else if (facility === 'Weekly Yoga Session'){ this.setState({weekly_yoga_checked: false})}
			else if (facility === 'Desktop Yoga'){ this.setState({desktop_yoga_checked: false})}
			else if (facility === 'Nutritionist Session'){ this.setState({nutritionist_checked: false})}
			else if (facility === 'Masala Bhangra'){ this.setState({masala_bhangra_checked: false})}
			else if (facility === 'Zumba Sessions'){ this.setState({zumba_checked: false})}
			else if (facility === 'Health Talks'){ this.setState({helth_talks_checked: false})}
			else if (facility === 'Ergonomics Session'){ this.setState({ergonomics_checked: false})}
			else if (facility === 'Others'){ this.setState({others_checked: false})}
		}
	}

	renderValidationMsg(){
		if (this.state.errors){
			return(<h4 style={{color: 'red'}}> Select atleast one activity </h4>)
		}
		else {
			return(<div/>)
		}
	}

  renderFaciltyModal(){
	return(
		<Modal
        title="Activities"
        visible={this.state.modalVisible}
        onOk={this.handleOk.bind(this)}
        onCancel={this.handleCancel}
        okText="Request Callback"
      >
	<Row type='flex' justify='start' style={{marginBottom: 20}}>
		{this.renderValidationMsg()}
	</Row>
	<Row type='flex' justify='start' style={{marginBottom: 15}}>
		<Col md={12}><Checkbox checked={this.state.healthy_diet_checked} onChange={this.updateFacility.bind(this,'Healthy Diet Plan')}>Healthy Diet Plan</Checkbox></Col>
		<Col md={12}><Checkbox checked={this.state.weekly_yoga_checked} onChange={this.updateFacility.bind(this, 'Weekly Yoga Session')}>Weekly Yoga Session</Checkbox></Col>
	</Row>
	<Row type='flex' justify='start' style={{marginBottom: 15}}>
		<Col md={12}><Checkbox checked={this.state.desktop_yoga_checked} onChange={this.updateFacility.bind(this, 'Desktop Yoga')}>Desktop Yoga</Checkbox></Col>
		<Col md={12}><Checkbox checked={this.state.nutritionist_checked} onChange={this.updateFacility.bind(this, 'Nutritionist Session')}>Nutritionist Session</Checkbox></Col>
	</Row>
	<Row type='flex' justify='start' style={{marginBottom: 15}}>
		<Col md={12}><Checkbox checked={this.state.masala_bhangra_checked} onChange={this.updateFacility.bind(this, 'Masala Bhangra')}>Masala Bhangra</Checkbox></Col>
		<Col md={12}><Checkbox checked={this.state.zumba_checked} onChange={this.updateFacility.bind(this, 'Zumba Sessions')}>Zumba Sessions</Checkbox></Col>
	</Row>
	<Row type='flex' justify='start' style={{marginBottom: 15}}>
		<Col md={12}><Checkbox checked={this.state.helth_talks_checked} onChange={this.updateFacility.bind(this, 'Health Talks')}>Health Talks</Checkbox></Col>
		<Col md={12}><Checkbox checked={this.state.ergonomics_checked} onChange={this.updateFacility.bind(this, 'Ergonomics Session')}>Ergonomics Session</Checkbox></Col>
	</Row>
	<Row type='flex' justify='start' style={{marginBottom: 15}}>
		<Col md={12}><Checkbox checked={this.state.others_checked} onChange={this.updateFacility.bind(this, 'Others')}>Others</Checkbox></Col>
	</Row>
	<Row type='flex' justify='start' style={{marginBottom: 30}}>
		<h4 className='semibold'>Notes:</h4>
		<TextArea rows={5} onChange={this.updateNotes} value={this.state.notes}/>
	</Row>
      </Modal>
	)
  }

  renderMessage(){
	if (this.state.requested){
		return(
			<Row type='flex' justify='center'>
				<h3 style={{color: this.state.msg_color}}>{this.state.msg}</h3>
			</Row>
		)
	} else {
		return(<div/>)
	}
  }

  render(){
	return(
		<div>
			<Breadcrumb list={[{ text: 'Activities', link: '#' }]} classes='mb-1' />
	<div>
		<Row>
			<Col span={12}>
			</Col>
			<Col span={12}>
						<Row type='flex' justify='end'>
							<Button type='primary' size='large' onClick={this.enableModal}> Plan Activity </Button>
						</Row>
					</Col>
				</Row>
				{this.renderMessage()}
			</div>
			<Spin spinning={this.state.loading}>
			</Spin>
			{this.renderFaciltyModal()}
		</div>
	)
  }

}

export default Facilities;